export const editorModes = {
  html: 'html',
  liquid: 'liquid',
}

export const editorModeDescriptions = {
  [editorModes.html]: 'Escribe tu mensaje y elige qué bloques de contenido incluir.',
  [editorModes.liquid]: 'Pega tu propio HTML y añade variables. Lo enviaremos exactamente como lo hayas diseñado.',
}
